import Footer from "../../footer/Footer";
import "./Archetypes.scss";
import leftarrowblack from "../../../assets/images/left-arrow-black.png";
import floodprofing from "../../../assets/images/floodprofing.png";
import cross from "../../../assets/images/cross.png";
import right from "../../../assets/images/right.png";
import inprogress from "../../../assets/images/inprogress.png";
import Accordion from "react-bootstrap/Accordion";
const ConcessionalFinance = () => {
  return (
    <>
      <div className="projects">
        <div className="sky-topper">
          <div className="container mobile">
            <div className="custom-row">
              <a href="/Resilience">
                <img
                  src={leftarrowblack}
                  alt="back"
                  className="left-arrow-black"
                />
                <div className="back">Back</div>
              </a>
            </div>
            <div className="page-title">Concessional Finance</div>
          </div>
          <div className="container desktop">
            <div className="custom-row">
              <a href="/Resilience">
                <img
                  src={leftarrowblack}
                  alt="back"
                  className="left-arrow-black"
                />
                <div className="back">Back</div>
              </a>
              <div className="page-title">Concessional Finance</div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="title projects-title">
            ~$5.7bn investment in concessional loans required to implement
            <span> public infrastructure & policy projects</span>
          </div>
          <div className="project-desc-title">How Can You Get Involved?</div>
          <div className="project-desc-desc">
            <span>Provide concessional financing</span> to implement key public
            infrastructures projects
          </div>
          <div className="legends">
            <div>
              <img src={right} alt="right" className="cross-right" />
              <span>Completed</span>
            </div>
            <div>
              <img src={cross} alt="cross" className="cross-right" />
              <span>Not yet started</span>
            </div>
            <div>
              <img src={inprogress} alt="inprogress" className="cross-right" />
              <span>In progress</span>
            </div>
          </div>
          <div className="project-col mobile">
            <div className="project-row">
              <div className="project-desc-title">Costal Embankments</div>
              <div className="project-desc-desc">
                Reinforcement of existing{" "}
                <span>18km of coastal embankment</span> and building{" "}
                <span>additional 10km of sea walls in 5 LGA</span>
              </div>
            </div>
            <div className="investment">INVESTMENT: $0.9-1.2bn</div>
            <div className="project-row">
              <div className="project-desc-title">Primary Drainage Systems</div>
              <div className="project-desc-desc">
                Construct of{" "}
                <span>
                  1,100km+ network of primary drainage system in 4 regions
                </span>
              </div>
            </div>
            <div className="investment">INVESTMENT: $3bn</div>
            <div className="project-row">
              <div className="project-desc-title">
                Secondary Drainage Systems
              </div>
              <div className="project-desc-desc">
                Build{" "}
                <span>
                  new &amp; rehabilitate existing secondary drainage systems
                </span>{" "}
                that feed the primary channels
              </div>
            </div>
            <div className="investment">INVESTMENT: $170mn</div>
            <div className="project-row">
              <div className="project-desc-title">
                Floodproofing Inner-City Roads
              </div>
              <div className="project-desc-desc">
                Construction and rehabilitation of critical transport links
                i.e., inner-city roads that will be inundated across{" "}
                <span>10 the vulnerable LGAs</span>
              </div>
            </div>
            <div className="investment">INVESTMENT: $350mn</div>
            <div className="project-row">
              <div className="project-desc-title">
                Retrofitting manufacturing plants
              </div>
              <div className="project-desc-desc">
                Retrofit 350 manufacturing plants with cool surfaces, green
                building envelopes and cooling systems –{" "}
                <span>Kosofe, Apapa and Eti Osa</span>
              </div>
            </div>
            <div className="investment">INVESTMENT: $45mn</div>
            <div className="project-row">
              <div className="project-desc-title">Cool Pavements</div>
              <div className="project-desc-desc">
                Retrofitting of <span>1,800km roads</span> with cool pavement in{" "}
                <span>5 most impacted LGA</span> to alleviate the impact of
                extreme heat and the associated health and productivity impacts
              </div>
            </div>
            <div className="investment">INVESTMENT: $70mn</div>
            <div className="project-row">
              <div className="project-desc-title">
                Medical Infrastructure Blueprint
              </div>
              <div className="project-desc-desc">
                Build of new <span>hospitals</span> and primary health care
                facilities in underserved parts of Lagos
              </div>
            </div>
            <div className="investment">INVESTMENT: TBD</div>
            <div className="project-row">
              <div className="project-desc-title">
                Digitalization of healthcare system
              </div>
              <div className="project-desc-desc">
                Increasing use of electronic medical records and smart health
                Information Platform
              </div>
            </div>
            <div className="investment">INVESTMENT: $1bn</div>
            <div className="project-row">
              <div className="project-desc-title">
                Health insurance solutions
              </div>
              <div className="project-desc-desc">
                Provide health insurance to <span>~320k</span> vulnerable
                populations in exposed LGAs
              </div>
            </div>
            <div className="investment">INVESTMENT: $20mn</div>
            <div className="project-row">
              <div className="project-desc-title">Heat Reduction</div>
              <div className="project-desc-desc">
                Re-design 5 LGAs for heat reduction (e.g, street grid, shading
                structure)-{" "}
                <span>
                  Badagry, Ikorodu, Ibeju lekki, Epe and part of Eti Osa
                </span>
              </div>
            </div>
            <div className="investment">INVESTMENT: $2mn</div>
          </div>
          <table className="desktop">
            <thead>
              <tr>
                <td>Project Name</td>
                <td>Investment</td>
                <td>Design Study</td>
                <td>Implementation</td>
                <td>Next Steps</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">Costal Embankments</div>
                    <div className="project-desc-desc">
                      Reinforcement of existing{" "}
                      <span>18km of coastal embankment</span> and building{" "}
                      <span>additional 10km of sea walls in 5 LGA</span>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">$0.9-1.2bn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>

              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Primary Drainage Systems
                    </div>
                    <div className="project-desc-desc">
                      Construct of{" "}
                      <span>
                        1,100km+ network of primary drainage system in 4 regions
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">$3bn</div>
                </td>
                <td className="cross-td">
                  <img src={right} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Secondary Drainage Systems
                    </div>
                    <div className="project-desc-desc">
                      Build{" "}
                      <span>
                        new &amp; rehabilitate existing secondary drainage
                        systems
                      </span>{" "}
                      that feed the primary channels
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">$170mn</div>
                </td>
                <td className="cross-td">
                  <img src={right} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Floodproofing Inner-City Roads
                    </div>
                    <div className="project-desc-desc">
                      Construction and rehabilitation of critical transport
                      links i.e., inner-city roads that will be inundated across{" "}
                      <span>10 the vulnerable LGAs</span>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">$350mn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Retrofitting manufacturing plants
                    </div>
                    <div className="project-desc-desc">
                      Retrofit 350 manufacturing plants with cool surfaces,
                      green building envelopes and cooling systems –{" "}
                      <span>Kosofe, Apapa and Eti Osa</span>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">$45mn</div>
                </td>
                <td className="cross-td">
                  <img src={right} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">Cool Pavements</div>
                    <div className="project-desc-desc">
                      Retrofitting of <span>1,800km roads</span> with cool
                      pavement in <span>5 most impacted LGA</span> to alleviate
                      the impact of extreme heat and the associated health and
                      productivity impacts
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">$70mn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Medical Infrastructure Blueprint
                    </div>
                    <div className="project-desc-desc">
                      Build of new <span>hospitals</span> and primary health
                      care facilities in underserved parts of Lagos
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">TBD</div>
                </td>
                <td className="cross-td">
                  <img src={inprogress} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Policy</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Digitalization of healthcare system
                    </div>
                    <div className="project-desc-desc">
                      Increasing use of electronic medical records and smart
                      health Information Platform
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">$1bn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Policy</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Health insurance solutions
                    </div>
                    <div className="project-desc-desc">
                      Provide health insurance to <span>~320k</span> vulnerable
                      populations in exposed LGAs
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">$20mn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Policy</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">Heat Reduction</div>
                    <div className="project-desc-desc">
                      Re-design 5 LGAs for heat reduction (e.g, street grid,
                      shading structure)-{" "}
                      <span>
                        Badagry, Ikorodu, Ibeju lekki, Epe and part of Eti Osa
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">$2mn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
            </tbody>
          </table>
          <div className="assumptions"></div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ConcessionalFinance;
